// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21.9999 2H8V7H13V22H21.9999V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 9H11V21.9976H2V9ZM5 17V19H8V17H5Z"}}]};

const SystemDeviceFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'system-device-filled',
    ref,
    icon: element,
  },
));

SystemDeviceFilledIcon.displayName = 'SystemDeviceFilledIcon';

export default SystemDeviceFilledIcon;
